var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{attrs:{"title":"Billing","current-name":_vm.$options.name}},[_c('h1',[_vm._v(_vm._s(_vm.$options.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }